(function() {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hue', {
                parent: 'entity',
                url: '/hue',
                data: {
                    authorities: ["ROLE_LOGO_SETTING"],
                    pageTitle: 'global.menu.entities.hue'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/hue/hue.html',
                        controller: 'HueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
